import * as React from 'react';
import { connect } from 'react-redux';
import { compose, withHandlers, withProps } from 'recompose';
import { reduxForm, formValueSelector } from 'redux-form';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { withNotifications } from '@components/hoc/withNotifications';
import { setPassword } from './_employeesActions';

import { Input, InputField } from '@components/form';
import { Col, Grid, Row } from 'react-flexbox-grid';
import { required, validatePasswordPolicy } from '@utils/validators';

const selector = formValueSelector('module-employees');

const enhance = compose<any, any>(
  withNotifications({ setPassword }),
  connect(state => selector(state, 'id', 'username', 'password')),
  withProps(({ username }) => ({
    initialValues: {
      username
    }
  })),
  withHandlers({
    onSubmit: ({ id, username, setPasswordNotify, closeItem, handleLoader }) => async formValues => {
      handleLoader(true);
      const res = await setPasswordNotify(id, formValues);
      if (res && username !== formValues.username) {
        window.location.reload();
        return;
      }
      handleLoader(false);
      closeItem();
    }
  }),
  reduxForm({ form: 'credentials-form' })
);

const LoginForm = ({ handleSubmit, closeItem }) => (
  <form onSubmit={handleSubmit}>
    <Grid fluid={true}>
      <Row>
        <Col className="grid-system-margin" />
      </Row>
      <Row>
        <Col md={6}>
          <h4>Přihlašovací údaje</h4>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <InputField component={Input} id="username" name="username" label="Uživatelské jméno *" validate={required} />
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <InputField
            component={Input}
            type={'password'}
            id="password"
            name="password"
            label="Heslo"
            validate={validatePasswordPolicy}
          />
        </Col>
      </Row>
      <Row>
        <Col className="grid-system-margin" />
      </Row>
      <Row>
        <Col md={4}>
          <Button primary={true} type="submit" label="Změnit přihlasovací údaje" />
        </Col>
        <Col md={2}>
          <Button onClick={closeItem} label="Zrušit" />
        </Col>
      </Row>
      <Row>
        <Col className="grid-system-margin" />
      </Row>
    </Grid>
  </form>
);

export const EmployeesFormLogin = enhance(LoginForm);



// WEBPACK FOOTER //
// ./src/modules/employees/EmployeesFormLogin.tsx